import React from 'react';
import './assucartegrise.scss'
import Info from '../../../../../../assets/images/assucartegrise/info.svg'

const Assucartegrise = () => {
    return (
        <div className={'assucartegrise m-4 position-relative'}>
            <div className="position-absolute need-help-assucartegrise rounded fs-5 fw-bold w-75">
                <img src={Info} alt="Besoin d'aide" width={40}/>
                <p className={'d-inline-block m-0'}>Besoin d'aide ?</p>
            </div>
            <div className="px-5 content-assucartegrise pt-5">
                <p><b>Vous devez mettre votre carte grise à votre nom ?</b></p>
                <p>Grâce à Certimat, partenaire 100% sécurisé, mettez votre carte grise à jour simplement.</p>
                <p className={'m-0'}>✔ Traitement immédiat</p>
                <p className={'m-0'}>✔ Démarche en ligne</p>
                <p className={'m-0'}>✔ Payement de vos taxes jusqu’en 10 fois</p>
                <a className="w-100 my-4 btn btn-primary rounded-5 d-block d-lg-inline-block me-5 text-uppercase"
                   href="https://certimat.fr/prescripteurs?partner=3871" target="_blank">Faire ma carte grise</a>
            </div>
        </div>
    );
};

export default Assucartegrise;